import { render, staticRenderFns } from "./exchange-goods.component.vue?vue&type=template&id=6eeac2e8"
import script from "./exchange-goods.component.vue?vue&type=script&lang=js"
export * from "./exchange-goods.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports